import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-list-ordered"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M10 12h11\"></path><path d=\"M10 18h11\"></path><path d=\"M10 6h11\"></path><path d=\"M4 10h2\"></path><path d=\"M4 6h1v4\"></path><path d=\"M6 18H4c0-1 2-2 2-3s-1-1.5-2-1\"></path>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_8]))
}
export default { render: render }